'use client';

import { ProductCard } from '@curology/ui-components-web/react/Card/ProductCard';
import { ProductCardContent } from '@curology/ui-components-web/react/Card/ProductCard/ProductCardContent';
import { Label } from '@curology/ui-components-web/react/Label';
import { Link } from '@curology/ui-components-web/react/Link';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { DATA_KEYS } from '@/consts/dataKeys';

import HairValuePropTags from './hairValuePropTags';
import ProductCardImageCarousel from './productCardImageCarousel';
import { useProductIngredientsModalState } from '../hooks/useProductIngredientsModalState';

export const HairRxCard = () => {
  const { rxCard, patient } = useDataProvider(DATA_KEYS.productSelection);
  const { setModalCard } = useProductIngredientsModalState();
  const [volumeText, quantityText] = rxCard.volume?.split(' • ') ?? [];

  return (
    <ProductCard className="cur-p-4">
      <ProductCardContent
        className="cur-cursor-pointer"
        data-sentry-id="Show product modal"
        image={
          <ProductCardImageCarousel
            aspectRatio="1:1"
            card={rxCard}
            patient={patient}
            showRecommendationTag={false}
          />
        }
        onClick={() => setModalCard(rxCard)}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            setModalCard(rxCard);
          }
        }}
        tabIndex={0}
        title={
          <div className="cur-flex cur-justify-between">
            <Typography as="p" size="h3" weight="bold">
              {rxCard.name}
              <sup>Rx</sup> for hair growth
            </Typography>
          </div>
        }
      >
        <Typography size="body">
          Grow visibly thicker, stronger hair with Hair Formula<sup>Rx</sup>—a
          personalized prescription solution that tackles hair loss and improves
          hair growth.<sup>△</sup>
        </Typography>
        <HairValuePropTags />
        <hr className="cur-bg-border-disabled cur-border-0 cur-h-[1px] cur-mb-2" />
        <div>
          <Typography as="p" size="body" weight="bold">
            Combines 3 clinically proven ingredients that regrow hair in as
            little as 3 months<sup>△</sup>
          </Typography>
          <div className="cur-flex cur-mb-2">
            <Label className="cur-mr-2">Prescription</Label>
            <Label>Personalized</Label>
          </div>
          <Typography as="p" size="body">
            A licensed dermatology provider selects active ingredients that work
            together to boost efficacy and stimulate hair follicles.
          </Typography>
          <Link
            className="cur-block cur-mb-1"
            href="."
            onClick={(e) => {
              e.preventDefault();
              setModalCard(rxCard);
            }}
            size="meta"
          >
            See ingredients and more
          </Link>
        </div>
        <hr className="cur-bg-border-disabled cur-border-0 cur-h-[1px] cur-mb-2" />
        <div>
          <Typography as="p" className="cur-mb-0" size="body" weight="bold">
            {quantityText}
          </Typography>
          <Typography as="p" size="body">
            {volumeText}
          </Typography>
        </div>
      </ProductCardContent>
    </ProductCard>
  );
};
